(()=>{
'use strict';
if(window.__VR_PRODUCT_LIGHTBOX__) return;
window.__VR_PRODUCT_LIGHTBOX__=true;

const state={items:[],index:0,scale:1,tx:0,ty:0,pointerId:null,startX:0,startY:0,lastX:0,lastY:0,moved:false};
let dialog,mainImage,caption,counter,thumbs,prev,next,closeBtn,viewport;

function injectStyles(){
  if(document.getElementById('vr-product-lightbox-style')) return;
  const style=document.createElement('style');
  style.id='vr-product-lightbox-style';
  style.textContent=`
    media-gallery .product-media__image{cursor:zoom-in}
    #vr-product-lightbox{width:100vw;height:100dvh;max-width:none;max-height:none;margin:0;padding:0;border:0;background:#02070c;color:#fff;overflow:hidden}
    #vr-product-lightbox::backdrop{background:rgba(0,0,0,.94)}
    .vr-plb-shell{height:100%;display:grid;grid-template-rows:auto minmax(0,1fr) auto;background:radial-gradient(circle at 50% 35%,#0a1722 0,#02070c 62%)}
    .vr-plb-top{display:grid;grid-template-columns:1fr auto 1fr;align-items:center;padding:14px 18px;gap:12px;z-index:3}
    .vr-plb-counter{justify-self:center;font:700 13px/1.2 system-ui,sans-serif;letter-spacing:.04em;color:#c7d8e5}
    .vr-plb-close{justify-self:end;width:44px;height:44px;border:1px solid #31516a;border-radius:12px;background:#071724;color:#fff;font-size:26px;line-height:1;cursor:pointer}
    .vr-plb-close:hover{background:#10293d;border-color:#39a8ff}
    .vr-plb-stage{position:relative;min-height:0;display:flex;align-items:center;justify-content:center;overflow:hidden;padding:10px 82px 18px}
    .vr-plb-image{display:block;max-width:min(88vw,1500px);max-height:calc(100dvh - 190px);width:auto;height:auto;object-fit:contain;user-select:none;-webkit-user-drag:none;cursor:zoom-in;touch-action:none;transition:opacity .18s ease,transform .24s ease;transform:translate3d(0,0,0) scale(1);transform-origin:center center}
    .vr-plb-image.is-zoomed{cursor:grab;transition:opacity .18s ease,transform .12s ease-out}
    .vr-plb-image.is-dragging{cursor:grabbing;transition:none}
    .vr-plb-arrow{position:absolute;top:50%;translate:0 -50%;width:52px;height:64px;border:1px solid #31516a;border-radius:14px;background:rgba(7,23,36,.84);color:#fff;font-size:34px;line-height:1;display:grid;place-items:center;cursor:pointer;z-index:3;backdrop-filter:blur(8px)}
    .vr-plb-arrow:hover{background:#12334d;border-color:#39a8ff}
    .vr-plb-prev{left:18px}.vr-plb-next{right:18px}
    .vr-plb-arrow[hidden]{display:none}
    .vr-plb-bottom{display:grid;gap:8px;padding:8px 18px 16px;background:linear-gradient(transparent,rgba(0,0,0,.38))}
    .vr-plb-caption{text-align:center;min-height:18px;color:#c7d8e5;font:500 13px/1.35 system-ui,sans-serif}
    .vr-plb-thumbs{display:flex;gap:8px;justify-content:center;overflow-x:auto;scrollbar-width:thin;padding:3px 0 4px}
    .vr-plb-thumb{flex:0 0 62px;width:62px;height:62px;padding:3px;border:1px solid #31516a;border-radius:10px;background:#071724;cursor:pointer;opacity:.66;transition:.18s ease}
    .vr-plb-thumb img{display:block;width:100%;height:100%;object-fit:contain;border-radius:7px}
    .vr-plb-thumb:hover,.vr-plb-thumb[aria-selected="true"]{opacity:1;border-color:#39a8ff;box-shadow:0 0 0 1px #39a8ff inset;transform:translateY(-2px)}
    .vr-plb-hint{position:absolute;bottom:22px;left:50%;translate:-50% 0;padding:6px 10px;border-radius:999px;background:rgba(0,0,0,.55);color:#d6e7f3;font:600 11px/1 system-ui,sans-serif;pointer-events:none;opacity:.75}
    html.vr-plb-open,html.vr-plb-open body{overflow:hidden!important}
    @media(max-width:749px){
      .vr-plb-top{padding:10px 12px}.vr-plb-close{width:40px;height:40px;border-radius:10px}
      .vr-plb-stage{padding:4px 8px 10px}.vr-plb-image{max-width:96vw;max-height:calc(100dvh - 168px)}
      .vr-plb-arrow{width:42px;height:54px;font-size:28px;background:rgba(7,23,36,.68)}
      .vr-plb-prev{left:8px}.vr-plb-next{right:8px}
      .vr-plb-thumbs{justify-content:flex-start}.vr-plb-thumb{flex-basis:54px;width:54px;height:54px}
      .vr-plb-hint{bottom:14px}
    }
    @media(prefers-reduced-motion:reduce){.vr-plb-image,.vr-plb-thumb{transition:none!important}}
  `;
  document.head.appendChild(style);
}

function mount(){
  if(dialog) return;
  injectStyles();
  dialog=document.createElement('dialog');
  dialog.id='vr-product-lightbox';
  dialog.setAttribute('aria-label','Galeria de imagens do produto');
  dialog.innerHTML=`
    <div class="vr-plb-shell">
      <div class="vr-plb-top">
        <span></span><div class="vr-plb-counter" aria-live="polite"></div>
        <button class="vr-plb-close" type="button" aria-label="Fechar apresentação">×</button>
      </div>
      <div class="vr-plb-stage">
        <button class="vr-plb-arrow vr-plb-prev" type="button" aria-label="Imagem anterior">‹</button>
        <img class="vr-plb-image" alt="">
        <button class="vr-plb-arrow vr-plb-next" type="button" aria-label="Imagem seguinte">›</button>
        <div class="vr-plb-hint">Clique para ampliar · Esc para fechar</div>
      </div>
      <div class="vr-plb-bottom">
        <div class="vr-plb-caption"></div>
        <div class="vr-plb-thumbs" role="list" aria-label="Miniaturas"></div>
      </div>
    </div>`;
  document.body.appendChild(dialog);
  mainImage=dialog.querySelector('.vr-plb-image');
  caption=dialog.querySelector('.vr-plb-caption');
  counter=dialog.querySelector('.vr-plb-counter');
  thumbs=dialog.querySelector('.vr-plb-thumbs');
  prev=dialog.querySelector('.vr-plb-prev');
  next=dialog.querySelector('.vr-plb-next');
  closeBtn=dialog.querySelector('.vr-plb-close');
  viewport=dialog.querySelector('.vr-plb-stage');

  closeBtn.addEventListener('click',close);
  prev.addEventListener('click',()=>go(-1));
  next.addEventListener('click',()=>go(1));
  dialog.addEventListener('cancel',e=>{e.preventDefault();close()});
  dialog.addEventListener('keydown',e=>{
    if(e.key==='ArrowLeft'){e.preventDefault();go(-1)}
    else if(e.key==='ArrowRight'){e.preventDefault();go(1)}
    else if(e.key==='Escape'){e.preventDefault();close()}
  });
  dialog.addEventListener('click',e=>{if(e.target===dialog||e.target===dialog.querySelector('.vr-plb-shell')) close()});
  thumbs.addEventListener('click',e=>{
    const b=e.target.closest('[data-vr-plb-index]');
    if(!b) return;
    select(Number(b.dataset.vrPlbIndex));
  });
  mainImage.addEventListener('click',e=>{
    if(state.moved){state.moved=false;return}
    const rect=mainImage.getBoundingClientRect();
    if(state.scale===1){
      state.scale=2;
      mainImage.style.transformOrigin=`${((e.clientX-rect.left)/rect.width)*100}% ${((e.clientY-rect.top)/rect.height)*100}%`;
    }else resetZoom();
    applyTransform();
  });
  mainImage.addEventListener('pointerdown',e=>{
    state.pointerId=e.pointerId;state.startX=e.clientX;state.startY=e.clientY;state.lastX=e.clientX;state.lastY=e.clientY;state.moved=false;
    mainImage.setPointerCapture?.(e.pointerId);
    if(state.scale>1) mainImage.classList.add('is-dragging');
  });
  mainImage.addEventListener('pointermove',e=>{
    if(state.pointerId!==e.pointerId) return;
    const dx=e.clientX-state.lastX,dy=e.clientY-state.lastY;
    if(Math.abs(e.clientX-state.startX)+Math.abs(e.clientY-state.startY)>10) state.moved=true;
    if(state.scale>1){state.tx+=dx;state.ty+=dy;applyTransform()}
    state.lastX=e.clientX;state.lastY=e.clientY;
  });
  const pointerEnd=e=>{
    if(state.pointerId!==e.pointerId) return;
    const swipe=e.clientX-state.startX;
    const vertical=e.clientY-state.startY;
    if(state.scale===1&&Math.abs(swipe)>55&&Math.abs(swipe)>Math.abs(vertical)) go(swipe<0?1:-1);
    state.pointerId=null;mainImage.classList.remove('is-dragging');
  };
  mainImage.addEventListener('pointerup',pointerEnd);
  mainImage.addEventListener('pointercancel',pointerEnd);
}

function highRes(img){return img.getAttribute('data_max_resolution')||img.currentSrc||img.src||''}
function collect(gallery){
  const all=[...gallery.querySelectorAll('.product-media__image')].filter(img=>!img.closest('zoom-dialog'));
  const seen=new Set(),items=[];
  for(const img of all){
    const src=highRes(img);if(!src||seen.has(src)) continue;seen.add(src);
    items.push({src,thumb:img.currentSrc||img.src||src,alt:img.alt||''});
  }
  return items;
}
function resetZoom(){state.scale=1;state.tx=0;state.ty=0;if(mainImage){mainImage.style.transformOrigin='center center';applyTransform()}}
function applyTransform(){if(!mainImage)return;mainImage.style.transform=`translate3d(${state.tx}px,${state.ty}px,0) scale(${state.scale})`;mainImage.classList.toggle('is-zoomed',state.scale>1)}
function select(index){
  if(!state.items.length) return;
  state.index=(index+state.items.length)%state.items.length;resetZoom();
  const item=state.items[state.index];
  mainImage.style.opacity='0';
  const pre=new Image();pre.onload=()=>{mainImage.src=item.src;mainImage.alt=item.alt||'Imagem do produto';mainImage.style.opacity='1'};pre.onerror=()=>{mainImage.src=item.src;mainImage.style.opacity='1'};pre.src=item.src;
  caption.textContent=item.alt||'';
  counter.textContent=`${state.index+1} / ${state.items.length}`;
  const multiple=state.items.length>1;prev.hidden=!multiple;next.hidden=!multiple;thumbs.hidden=!multiple;
  [...thumbs.children].forEach((b,i)=>b.setAttribute('aria-selected',String(i===state.index)));
  thumbs.children[state.index]?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
  const before=state.items[(state.index-1+state.items.length)%state.items.length],after=state.items[(state.index+1)%state.items.length];
  if(multiple){new Image().src=before.src;new Image().src=after.src}
}
function go(delta){if(state.items.length>1)select(state.index+delta)}
function openFrom(img){
  const gallery=img.closest('media-gallery');if(!gallery)return;
  mount();state.items=collect(gallery);if(!state.items.length)return;
  const src=highRes(img);const found=state.items.findIndex(x=>x.src===src);state.index=found>=0?found:0;
  thumbs.innerHTML=state.items.map((x,i)=>`<button type="button" class="vr-plb-thumb" data-vr-plb-index="${i}" aria-selected="${i===state.index}" aria-label="Abrir imagem ${i+1}"><img src="${x.thumb}" alt=""></button>`).join('');
  document.documentElement.classList.add('vr-plb-open');dialog.showModal();select(state.index);closeBtn.focus({preventScroll:true});
}
function close(){if(!dialog?.open)return;resetZoom();dialog.close();document.documentElement.classList.remove('vr-plb-open')}

document.addEventListener('click',e=>{
  const img=e.target instanceof Element?e.target.closest('media-gallery .product-media__image'):null;
  if(!(img instanceof HTMLImageElement)||img.closest('zoom-dialog')) return;
  e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();openFrom(img);
},true);

mount();
})();